/* Cart enhancements:
   1) Live coupon — validate / apply / remove via the Cart Ajax API, shown as a removable pill.
   2) Custom quantity stepper — replaces Halo's cart-update-quantity (mis-aligned glyphs +
      out-of-order AJAX race). Own markup (geometric − / + bars, perfectly centred), debounced
      /cart/change.js so only the final quantity is sent.
   Totals are always re-rendered from /cart.js; automatic promotions keep their label. */
(function () {
  var TRASH = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>';

  var selfUpdating = false, guardTimer = null;
  function beginSelf() { selfUpdating = true; clearTimeout(guardTimer); guardTimer = setTimeout(function () { selfUpdating = false; }, 160); }

  function fmt(cents) {
    var sym = '$';
    var ref = document.querySelector('.cart-total-grandtotal .cart-total-value .text, .cart-total-subtotal .cart-total-value .text');
    if (ref) { var m = ref.textContent.match(/^[^\d-]+/); if (m && m[0].trim()) sym = m[0].trim(); }
    var n = (Math.abs(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return sym + n;
  }

  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function setDiscount(code) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: code }) }).then(function (r) { return r.json(); });
  }
  // Use the 1-based LINE INDEX, not the key: the line key changes when a discount attaches
  // (the hash encodes discount state), so a key captured at page load goes stale.
  function changeQty(lineIndex, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: lineIndex, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  function appliedCode(cart) {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) { if (codes[i].applicable && codes[i].code) return codes[i].code; }
    return null;
  }

  function renderTotals(cart) {
    beginSelf();
    var sub = document.querySelector('.cart-total-subtotal .cart-total-value .text');
    if (sub) sub.textContent = fmt(cart.original_total_price);
    var grands = document.querySelectorAll('.cart-total-grandtotal .cart-total-value');
    for (var i = 0; i < grands.length; i++) {
      var t = grands[i].querySelector('.text'); if (t) t.textContent = fmt(cart.total_price);
      grands[i].setAttribute('data-cart-total-value', cart.total_price);
    }
    var savRow = document.querySelector('.cart-total-savings');
    var savVal = document.querySelector('.cart-total-savings [data-saved-discount-value]') || document.querySelector('.cart-total-savings .cart-total-value .text');
    if (savRow && savVal) {
      if (cart.total_discount > 0) {
        savRow.style.display = '';
        var parts = [];
        (cart.cart_level_discount_applications || []).forEach(function (d) {
          var title = d.title || (d.discount_application && d.discount_application.title);
          var amt = (typeof d.total_allocated_amount === 'number') ? d.total_allocated_amount : null;
          if (title && amt != null) parts.push(title + ' (-' + fmt(amt) + ')');
        });
        savVal.textContent = parts.length ? parts.join(', ') : '-' + fmt(cart.total_discount);
      } else { savRow.style.display = 'none'; }
    }
  }

  // Single source of truth for the totals: only the LATEST fetch is allowed to paint, so
  // overlapping refreshes (stepper + coupon observer) can't render a stale quantity.
  var renderSeq = 0;
  function refreshTotals() {
    var s = ++renderSeq;
    return getCart().then(function (cart) {
      if (s === renderSeq && cart && cart.items) renderTotals(cart);
      return cart;
    });
  }

  // Block checkout until every pending stepper change is committed (a fast click followed by
  // an immediate checkout would otherwise send the old quantity). Steppers register on their
  // row element so removed rows prune themselves.
  function eachStepper(fn) { document.querySelectorAll('.cart-item').forEach(function (row) { if (row._iqty) fn(row._iqty); }); }
  function anyPending() { var p = false; eachStepper(function (s) { if (s.pending()) p = true; }); return p; }
  function settleAll() {
    return new Promise(function (resolve) {
      eachStepper(function (s) { s.flush(); });
      if (!anyPending()) return resolve();
      var iv = setInterval(function () { if (!anyPending()) { clearInterval(iv); clearTimeout(to); resolve(); } }, 50);
      var to = setTimeout(function () { clearInterval(iv); resolve(); }, 6000);
    });
  }
  function bindCheckoutGuard() {
    var sel = '.button-checkout, #cart-checkout, .action-group .button-1';
    document.querySelectorAll(sel).forEach(function (btn) {
      if (btn.dataset.iqtyGuard) return; btn.dataset.iqtyGuard = '1';
      btn.addEventListener('click', function (e) {
        if (btn.dataset.iqtyPass) { btn.dataset.iqtyPass = ''; return; }   // our re-click — let it through
        if (!anyPending()) return;                                          // nothing pending — normal flow
        e.preventDefault(); e.stopImmediatePropagation();
        var prev = btn.textContent; btn.style.pointerEvents = 'none';
        settleAll().then(function () { btn.style.pointerEvents = ''; btn.dataset.iqtyPass = '1'; btn.click(); });
      }, true); // capture phase → runs before Halo's own handler
    });
  }

  // Update only the header count. Do NOT publish PUB_SUB cartUpdate: Halo's <cart-items>
  // listens and re-renders #main-cart-items from event sections we don't supply, which
  // blanks the line we just changed. We manage the DOM ourselves instead.
  function updateHeaderCount(cart) {
    var c = (cart && typeof cart.item_count === 'number') ? cart.item_count : null;
    if (c == null) return;
    document.querySelectorAll('[data-cart-count], .cart-count, .cart-item-count, .cart-count-bubble, .header__cart-count').forEach(function (el) {
      // replace a number inside e.g. "Cart (1)" or a bare count
      if (/\(\s*\d+\s*\)/.test(el.textContent)) el.textContent = el.textContent.replace(/\(\s*\d+\s*\)/, '(' + c + ')');
      else el.textContent = c;
    });
  }

  /* ---------- custom quantity stepper ---------- */
  function buildStepper(row) {
    if (row.dataset.iqtyDone) return;
    var rows = [].slice.call(document.querySelectorAll('.cart-item[data-line]'));
    var lineIndex = rows.indexOf(row) + 1; if (lineIndex < 1) return;
    var input = row.querySelector('.cart-item-qty-input, input.quantity[name="quantity"]');
    var qty = input ? (parseInt(input.value, 10) || 1) : 1;
    // hide Halo's quantity widget(s) hard (CSS uses !important elsewhere)
    row.querySelectorAll('.cart-item-quantity, cart-update-quantity').forEach(function (q) { q.style.setProperty('display', 'none', 'important'); });
    row.dataset.iqtyDone = '1';

    var st = document.createElement('div');
    st.className = 'iqty';
    st.innerHTML =
      '<button type="button" class="iqty-btn iqty-minus" aria-label="Decrease quantity"><span class="iqty-bar"></span></button>' +
      '<span class="iqty-num" aria-live="polite">' + qty + '</span>' +
      '<button type="button" class="iqty-btn iqty-plus" aria-label="Increase quantity"><span class="iqty-bar"></span><span class="iqty-bar iqty-bar--v"></span></button>';

    var host = row.querySelector('.cart-item-blocks-left') ||
               row.querySelector('.cart-item-blocks.small-screen-visible') || row;
    host.insertBefore(st, host.firstChild);

    var numEl = st.querySelector('.iqty-num');
    var target = qty;          // what the shopper wants (and what we display)
    var lastCommitted = qty;   // what the server is confirmed to hold
    var inFlight = false;

    // Commit IMMEDIATELY (no debounce) so the server stays current and checkout is never
    // behind. Requests are serialised: during one, extra clicks just move `target`, and the
    // newest target is sent right after. Totals come from /cart.js (keeps discount LABELS),
    // seq-guarded so a slow response can't repaint a stale quantity.
    function flush() {
      if (inFlight || target === lastCommitted) return;
      var sent = target;
      inFlight = true;
      changeQty(lineIndex, sent)
        .then(function () { return refreshTotals(); })
        .then(function (cart) {
          if (cart && cart.items) {
            var it = cart.items[lineIndex - 1];
            if (it) { lastCommitted = it.quantity; if (target === sent) { target = it.quantity; numEl.textContent = target; } }
            updateHeaderCount(cart);
            document.dispatchEvent(new CustomEvent('cart-enhance:changed')); // reconcile coupon pill
          }
        })
        .catch(function () {})
        .then(function () { inFlight = false; if (target !== lastCommitted) flush(); });
    }
    function change(delta) {
      var n = target + delta; if (n < 1) n = 1;
      if (n === target) return;
      target = n; numEl.textContent = target; flush();
    }
    st.querySelector('.iqty-minus').addEventListener('click', function () { change(-1); });
    st.querySelector('.iqty-plus').addEventListener('click', function () { change(1); });
    row._iqty = { pending: function () { return inFlight || target !== lastCommitted; }, flush: flush };
  }
  function initSteppers() {
    document.querySelectorAll('.cart-item[data-line]').forEach(buildStepper);
  }

  /* ---------- live coupon ---------- */
  function initCoupon() {
    var input = document.getElementById('cart-coupon-code');
    if (!input) return;
    var field = input.closest('.cart-coupon-code') || input.parentNode;
    if (!field || field.dataset.clcInit) return;
    field.dataset.clcInit = '1';

    var note = field.querySelector('.form-text');
    if (note) note.style.display = 'none';

    var row = document.createElement('div'); row.className = 'clc-row';
    input.parentNode.insertBefore(row, input); row.appendChild(input);
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'clc-apply'; btn.textContent = 'Apply'; row.appendChild(btn);
    var msg = document.createElement('div'); msg.className = 'clc-msg'; field.appendChild(msg);
    var pill = document.createElement('div'); pill.className = 'clc-pill'; pill.style.display = 'none'; field.appendChild(pill);

    var busy = false, currentCode = null;
    function setMsg(s, t) { msg.className = 'clc-msg clc-' + s; msg.textContent = t; }
    function showPill(code) {
      beginSelf();
      pill.innerHTML = '<span class="clc-pill-tag">' + code + '</span><button type="button" class="clc-trash" aria-label="Remove coupon">' + TRASH + '</button>';
      pill.style.display = 'inline-flex';
      pill.querySelector('.clc-trash').addEventListener('click', remove);
      row.style.display = 'none';
    }
    function hidePill() { beginSelf(); pill.style.display = 'none'; pill.innerHTML = ''; row.style.display = 'flex'; }

    function apply() {
      var code = (input.value || '').trim();
      if (!code) { setMsg('err', 'Please enter a coupon code.'); return; }
      if (busy) return; busy = true; btn.disabled = true; setMsg('load', 'Checking…');
      setDiscount(code).then(function (cart) {
        var codes = cart.discount_codes || [], dc = null;
        for (var i = 0; i < codes.length; i++) if (codes[i].code && codes[i].code.toLowerCase() === code.toLowerCase()) { dc = codes[i]; break; }
        if (dc && dc.applicable) {
          currentCode = dc.code || code; try { localStorage.setItem('storedDiscount', currentCode); } catch (e) {}
          renderTotals(cart); showPill(currentCode);
          setMsg('ok', cart.total_discount > 0 ? '✓ Applied — you save ' + fmt(cart.total_discount) + '.' : '✓ Coupon applied — your saving is shown at checkout.');
        } else { setDiscount('').catch(function () {}); try { localStorage.removeItem('storedDiscount'); } catch (e) {} setMsg('err', '“' + code + '” is not a valid coupon for this cart.'); }
      }).catch(function () { setMsg('err', 'Could not verify the code right now. Please try again.'); }).then(function () { busy = false; btn.disabled = false; });
    }
    function remove() {
      if (busy) return; busy = true; setMsg('load', 'Removing…'); currentCode = null;
      try { localStorage.removeItem('storedDiscount'); } catch (e) {}
      setDiscount('').then(function (cart) { renderTotals(cart); input.value = ''; hidePill(); setMsg('info', 'Coupon removed.'); })
        .catch(function () { input.value = ''; hidePill(); setMsg('info', 'Coupon removed.'); }).then(function () { busy = false; });
    }
    function resync() {
      if (busy) return;
      refreshTotals().then(function (cart) {
        if (!cart || !cart.items) return;
        var active = appliedCode(cart), stillInCart = false;
        if (currentCode) (cart.discount_codes || []).forEach(function (d) { if (d.code && d.code.toLowerCase() === currentCode.toLowerCase()) stillInCart = true; });
        if (active) { currentCode = active; showPill(currentCode); pill.classList.remove('clc-pill--off'); setMsg('ok', cart.total_discount > 0 ? '✓ Applied — you save ' + fmt(cart.total_discount) + '.' : '✓ Coupon applied.'); }
        else if (currentCode && stillInCart) { showPill(currentCode); pill.classList.add('clc-pill--off'); setMsg('info', '“' + currentCode + '” isn’t active right now — a larger automatic discount is applied.'); }
        else { currentCode = null; hidePill(); if (msg.classList.contains('clc-ok') || msg.classList.contains('clc-info')) setMsg('', ''); }
      }).catch(function () {});
    }

    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });

    getCart().then(function (cart) {
      renderTotals(cart);
      var code = appliedCode(cart);
      if (code) { currentCode = code; showPill(code); setMsg('ok', cart.total_discount > 0 ? '✓ Applied — you save ' + fmt(cart.total_discount) + '.' : '✓ Coupon applied — your saving is shown at checkout.'); }
    }).catch(function () {});

    var resyncTimer = null;
    function scheduleResync() { clearTimeout(resyncTimer); resyncTimer = setTimeout(resync, 200); }
    document.addEventListener('cart-enhance:changed', scheduleResync); // our stepper changed the cart
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { if (PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleResync); if (PUB_SUB_EVENTS.quantityUpdate) subscribe(PUB_SUB_EVENTS.quantityUpdate, scheduleResync); } } catch (e) {}
    var totalsEl = document.querySelector('.cart-totals');
    if (totalsEl && 'MutationObserver' in window) new MutationObserver(function () { if (!selfUpdating) scheduleResync(); }).observe(totalsEl, { childList: true, subtree: true, characterData: true });
  }

  // Halo re-renders the whole cart items block when a line is removed, which drops our
  // injected steppers (its native qty is CSS-hidden) — re-inject when a row is missing one.
  function watchCartItems() {
    var container = document.getElementById('main-cart-items') || document.querySelector('.cart-content-item[data-cart-content]');
    if (!container || container.dataset.iqtyWatch) return;
    container.dataset.iqtyWatch = '1';
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var missing = [].some.call(document.querySelectorAll('.cart-item[data-line]'), function (r) { return !r.querySelector('.iqty'); });
        if (missing) { initSteppers(); initCoupon(); bindCheckoutGuard(); }
      }, 120);
    }).observe(container, { childList: true, subtree: true });
  }

  function boot() { initSteppers(); initCoupon(); bindCheckoutGuard(); watchCartItems(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('cart:refresh', boot);
  document.addEventListener('cart:updated', boot);
})();
